module.exports = __webpack_public_path__ + "img/Z82_15.68450bd5.jpg";